import { RangerFirearmAssignmentLogItemComponentBase } from './ranger-firearm-assignment-log-item.component.base';
import { Component, ElementRef, Injector, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { CrudEditorParentService, CrudEditorSelfService, UserStorage } from '@scisys-uim/uim-common';
import { FirearmAssignment } from 'assets-model';
import { BusinessUnitService, RangerFirearmAssignmentLogService, RangerService, RefCodeStorage } from 'assets-service';
import { FirearmAssignmentListComponent } from '../../firearm_assignment/search/firearm-assignment-search.component';


@Component({
  selector: 'app-ranger-firearm-assignment-log-item',
  templateUrl: './ranger-firearm-assignment-log-item.component.html',
  styleUrls: ['./ranger-firearm-assignment-log-item.component.scss'],
  providers: [CrudEditorParentService],
  viewProviders: [CrudEditorSelfService]
})
export class RangerFirearmAssignmentLogItemComponent extends RangerFirearmAssignmentLogItemComponentBase {

  constructor(protected rangerFirearmAssignmentLogService: RangerFirearmAssignmentLogService,
    protected businessUnitService: BusinessUnitService,
    protected rangerService: RangerService,
    protected refCodeStorage: RefCodeStorage,
    protected fb: FormBuilder,
    protected elementRef: ElementRef,
    protected router: Router,
    protected route: ActivatedRoute,
    protected userStorage: UserStorage,
    protected dialog: MatDialog,
    protected injector: Injector,
    protected snackbar: MatSnackBar) {
    super(rangerFirearmAssignmentLogService, businessUnitService, rangerService, refCodeStorage, fb, elementRef, router, route, userStorage, dialog, injector, snackbar);
  }

  protected onInitAsyncComplete() {
    super.onInitAsyncComplete();
    this.businessUnitLoadSelectionList();
    this.rangerLoadSelectionList();
  }

  setDefaultDisabledFields() {
    super.setDefaultDisabledFields();
    if (!this.form) {
      return;
    }
  }

  itemSet() {
    super.itemSet();
  }

}





